import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
import { getBlockClassNames } from '@components/class-dropdown';

const Save = ({ attributes }) => {
  const { blockClassNames } = attributes;
  const classes = getBlockClassNames(blockClassNames);
  const blockProps = useBlockProps.save({
    className: `${classes}`,
  });

  return (
    <div {...blockProps}>
      <InnerBlocks.Content />
    </div>
  );
};

export default Save;
